import { render, staticRenderFns } from "./CustomerOrders.vue?vue&type=template&id=9d4bfb84&"
import script from "./CustomerOrders.vue?vue&type=script&lang=ts&"
export * from "./CustomerOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports